export default {
  noAdvisers: 'No users',
  autoassignation: 'Conversation Routing',
  acceptConversationsOffline: 'Accept conversations while offline',
  conversationLimit: 'Conversation limit',
  configurationSavedCorrectly: 'Configuration saved correctly',
  errorSavingConfiguration: 'Error saving configuration',
  templatesUpdated: 'Templates updated',
  errorUpdatingTemplates: 'Error updating templates',
  configurationDeletedCorrectly: 'Configuration deleted correctly',
  errorDeletingConfiguration: 'Error deleting configuration',
  projectId: 'Project ID',
  privateKeyId: 'Private key ID',
  privateId: 'Private ID',
  clientEmail: 'Client email',
  clientId: 'Client ID',
  authURI: 'Auth URI',
  tokenURI: 'Token URI',
  authProviderx509CertURL: 'Auth provider x509 Cert URL',
  clientx509CertURL: 'Client x509 Cert URL',
  version: 'Version',
  assistantId: 'Assistant ID',
  restoreContexts: 'RestoreContexts',
  botAlias: 'Bot alias',
  identityPoolId: 'Identity pool ID',
  keybeEnvironment: 'Keybe Environment',
  nipuEnvironment: 'Nipu Environment',
  constructionEnvironment: 'Construction Environment',
  educationEnvironment: 'Education Environment',
  KB1Environment: 'KB1 Environment',
  KB12Environment: 'KB1 2 Environment',
  KB13Environment: 'KB1 3 Environment',
  leisureEnvironment: 'Leisure Environment',
  retailEnvironment: 'Retail Environment',
  retailEnvironment1: 'Retail Environment 1',
  retailEnvironment2: 'Retail Environment 2',
  retailEnvironment3: 'Retail Environment 3',
  retailEnvironment4: 'Retail Environment 4',
  healthEnvironment: 'Health Environment',
  healthEnvironment2: 'Health Environment 2',
  turismEnvironment: 'Turism Environment',
  automotiveEnvironment: 'Automotive Environment',
  legalEnvironment: 'Legal Environment',
  coworkingEnvironment: 'Coworking Environment',
  financialEnvironment: 'Financial Environment',
  bellpiExternalEnvironment: 'Bellpi Environment - External',
  educationEnvironment1: 'Education Environment 1',
  healthEnvironment1: 'Health Environment 1',
  retailEnvironment5: 'Retail Environment 5',
  retailEnvironment6: 'Retail Environment 6',
  retailEnvironment7: 'Retail Environment 7',
  automotiveEnvironment1: 'Automotive Environment 1',
  constructionAndRealEstateEnvironment1: 'Construction and Real Estate Environment 1',
  leisureAndEntertaimentEnvironment1: 'Leisure and Entertaiment Environment 1',
  arbustaEnvironment: 'Arbusta Environment',
  RepuestosDarioEnvironment: 'Repuestos Dario Environment',
  smartbeemoEnvironment: 'smartbeemo Environment',
  lagilcoEnvironment: 'Ambiente Lagilco',
  bmartEnvironment: 'Ambiente bmart',
  addChatWebText: 'To add the web chat to your website, copy and paste the following script in the footer of your website',
  errorLoadingFacebookSDK: 'Error loading Facebook SDK',
  errorValidatingPermissions: 'Error validating permissions',
  endConnectionInProcess: 'Please finalize the current conection to start a new one',
  mustAcceptAllPermissions: 'You must accept all required permissions to continue',
  pageIsAlreadyConnected: 'The page is already connected to a Keybe app',
  facebookMessengerConnected: 'Facebook Messenger connected successfully',
  facebookMessengerExtended: 'Facebook Messenger extended successfully',
  instagramIsAlreadyConnected: 'This instagram is already connected to a Keybe app',
  instagramConnectedSuccessfully: 'Instagram connected successfully',
  instagramExtendedSuccessfully: 'Instagram extended successfully',
  instagramNotEligible: 'This instagram account is not eligible for API yet',
  administrateTemplates: 'Administrate templates',
  availableLines: 'Available lines',
  templatesAdministrator: 'Templates administrator',
  refreshTemplates: 'Refresh templates',
  search: 'Search',
  personalizedName: 'Personalized name',
  channelId: 'Channel ID',
  appName: 'App name',
  wsAppIntegrationId: 'Whatsapp App integration Id',
  wsSecretAppId: 'Whatsapp App secret ID',
  wsPassword: 'Whatsapp app password',
  wsAppId: 'Whatsapp App ID',
  verificationToken: 'Verification Token',
  igId: 'Instragram ID',
  pageId: 'Page ID',
  mode: 'Mode',
  principalColor: 'Main color',
  examine: 'Examine',
  howCanIHelpYou: 'How can I help you?',
  left: 'Left',
  right: 'Right',
  light: 'Light',
  dark: 'Dark',
  bubbleMessage: 'Bubble message',
  disableMultimediaMessages: 'Disable incoming multimedia messages (audio, video, images and pdf)',
  configForm: 'Chat widget form config',
  welcomeMessage: 'Welcome message',
  alignment: 'Alignment',
  openChatAutomatically: 'Open Chat Automatically',
  sitesOpenChatURL: 'URL of the sites that will open the chat',
  question: 'Question',
  finalizationOption: 'Conversation Tag',
  quickAnswer: 'Quick answer',
  inactivityMessage: 'Inactivity Message',
  inactivityTime: 'Inactivity time',
  textAnswers: 'Text responses',
  addAQuickResponse: 'Add a quick response',
  imageAnswers: 'Image responses',
  dragAnImage: 'Drag or upload an image here',
  pdfAnswers: 'PDF responses',
  dragPdf: 'Drag or upload a PDF here',
  videoAnswers: 'Video responses',
  dragVideo: 'Drag or upload a video here',
  cantSendOver10Files: 'Cant send over 10 files',
  cantSendFilesOver20mb: 'You cannot send files over 20MB',
  cantSendFilesOver16mbGeneral: 'You cannot send files over 16MB',
  cantSendFilesOver7mb: 'You cannot send images over 7MB for Instagram',
  cantSendFilesOver16mb: 'You cannot send videos over 16MB for WhatsApp',
  cantSendFilesOver5mb: 'You cannot send images over 5MB for WhatsApp',
  invalidFileType: 'Invalid file type',
  minutes: 'Minutes',
  hours: 'Hours',
  days: 'Days',
  enterInactivityMessage: 'Type inactivity message',
  timeToTriggerMessage: 'Time to trigger message',
  attentionHours: 'Availability',
  outOfServiceMessage: 'After hours message',
  blockMessageCompositor: 'Block message composer',
  timezone: 'Time zone',
  allDay: 'All day',
  verification: 'Verification',
  passwordChanged: 'Password changed',
  errorChangingPassword: 'Error changing password',
  addScript: 'To add the chat widget to your website, copy and paste this script in the footer of your website',
  identificationType: 'ID type',
  idDocument: 'ID number',
  authName: 'Full name',
  authEmail: 'email address',
  authPhone: 'Mobile phone',
  landlinePhone: 'Phone number',
  customizeConversation: 'Personalize your conversation',
  customizedQuestions: 'Add the questions you want to ask in the chat widget (maximum 5)',
  permanentMessages: 'Welcome messages',
  permanentMessagesDescription: 'Add here the messages you want to show as a welcome message',
  endConversationsReasons: 'Conversation tags',
  endConversationsReasonsDescription: 'Add conversation tags',
  quickResponses: 'Quick replies',
  textQuickResponse: 'Text',
  textQuickResponseDescription: 'Add text as quick replies',
  imageQuickResponse: 'Image',
  imageQuickResponseDescription: 'Add pictures as quick replies',
  videoQuickResponse: 'Video',
  videoQuickResponseDescription: 'Add videos as quick replies',
  pdfQuickResponse: 'PDF',
  pdfQuickResponseDescription: 'Add PDF as quick replies',
  automaticallyCloseChat: 'Automaticaly close conversations',
  endAfter: 'after',
  autoassignTitle: 'Conversation Routing',
  autoassignConversations: 'Automatically route conversations',
  balanced: 'Balanced',
  machineLearning: 'Machine Learning',
  linear: 'Linear',
  agentConversationsLimit: 'Conversation limit per user',
  autoassignByType: 'Route by type',
  rulesByAgent: 'Route per user',
  autoassignByTags: 'Route per groups',
  autoassignByTagsDescription: 'Prioritize the groups to assign an agent',
  createTag: 'Create Routing group',
  autoassignByGroups: 'Autoasignation per groups',
  autoassignByGroupsDescription: 'Restrict agents per groups',
  createGroup: 'Create group',
  tag: 'TAG',
  group: 'Group',
  agent: 'Agent',
  delete: 'Delete',
  deleteConfirmation: '¿Are you sure you want to delete',
  updateChanges: 'Update changes',
  type: 'Type',
  serverUrl: 'Server URL',
  fields: 'Fields',
  showTermsAndConditions: 'Show terms and conditions',
  termsAndConditionsUrl: 'Terms and conditions URL',
  termsAndConditionsMessage: 'Terms and conditions message',
  twoFactorAuthentication: '2FA',
  insertUrl: 'Add URL',
  insertMessage: 'Add message',
  noAuth: 'Without authentication',
  externalAuth: 'External authentication',
  atStart: 'At the begining',
  onDemand: 'On demand',
  rocioBertoneEnvironment: 'Ambiente Rocio Bertone',
  retailEnvironment8: 'Ambiente Retail 8',
  retailEnvironment9: 'Ambiente Retail 9',
  starSolucionesEnvironment: 'Ambiente Star Soluciones',
  sicoEnvironment: 'SICO',
  sico1Environment: 'SICO 1',
  templatesRefreshed: 'Templates refreshed',
  B2Wenvironment: 'Ambiente B2W',
  ivisaEnvironment: 'Ambiente Ivisa'
}
